import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react';
import { Checkbox, Heading, Paragraph } from '@digdir/designsystemet-react';

import { OppvarmingFormData } from '../../../types';
import { StyledCard } from '../../../../../../../components/registering/steps/base/form/detailingSelect/components/styledComponents';
import { CheckedContentWrapper, LeftBorderedContent } from '../common/styledComponents';
import { useOppvarmingValidation } from '../../hooks/useOppvarmingValidation';
import { oppvarmingSelectionFields } from '../../utils';

import { VarmekildeRadio } from './varmekildeRadio';
import { VannbarenVarme } from './vannbarenVarme';
import { Punktoppvarming } from './punktoppvarming';
import { VarmefordelingRadio } from './varmefordelingRadio';

export const Varmepumpe = () => {
  const { register, watch, formState } = useFormContext<OppvarmingFormData>();
  const { t } = useTranslation('', { keyPrefix: 'form.oppvarming' });
  const { validateOppvarmingSelection } = useOppvarmingValidation();

  const varmepumpeSelected = watch('varmepumpe.selected');
  const varmefordeling = watch('varmepumpe.value.varmefordeling');

  return (
    <Fragment>
      <Checkbox
        aria-invalid={!!formState.errors.varmepumpe?.selected}
        label={t('varmepumpe.label')}
        {...register('varmepumpe.selected', {
          validate: validateOppvarmingSelection,
          deps: oppvarmingSelectionFields,
          shouldUnregister: true
        })}
      />

      {varmepumpeSelected && (
        <CheckedContentWrapper>
          <LeftBorderedContent>
            <Heading level={3} data-size="2xs">
              {t('varmepumpe.heading')}
            </Heading>
            <Paragraph>{t('varmepumpe.description')}</Paragraph>
          </LeftBorderedContent>

          <StyledCard isActive>
            <VarmekildeRadio />

            <VarmefordelingRadio />
            {varmefordeling === 'vannbarenVarme' && <VannbarenVarme />}
            {varmefordeling === 'punktoppvarming' && <Punktoppvarming />}
          </StyledCard>
        </CheckedContentWrapper>
      )}
    </Fragment>
  );
};
